export default async function getVideoDuration(file) {
  return new Promise((resolve, reject) => {
    // Create a URL for the selected file
    const objectURL = URL.createObjectURL(file);

    // Create a new video element
    const video = document.createElement('video');

    // Add an event listener to get the duration when the metadata is loaded
    video.addEventListener('loadedmetadata', () => {
      // Access the duration property
      const duration = video.duration;
      setTimeout(function () {
        resolve(duration);
      }, 0);

      // Clean up by revoking the object URL and removing the video element
      URL.revokeObjectURL(objectURL);
      video.remove();
    });

    // Error handling for video loading
    video.addEventListener('error', (err) => {
      reject(err);
    });

    // Set the video element's source to the object URL
    video.src = objectURL;
  });
}
